import * as React from 'react';
import { FromPackage } from './FromPackage';
import { TDispatch } from '../../../../../../redux';
import { EPlacingType, selectPlacingType } from '../../../../../../redux/reducers';
import { selectActivePlacingType } from '../../../../../../selectors/publishTerms';
import { useDispatch, useSelector } from 'react-redux';

export const FromPackageContainer = () => {
  const placingType = useSelector(selectActivePlacingType);

  const dispatch = useDispatch<TDispatch>();

  const handlePackageChange = React.useCallback(
    (checked: boolean) => {
      dispatch(selectPlacingType(checked ? EPlacingType.package : EPlacingType.balance));
    },
    [dispatch],
  );

  return <FromPackage checked={placingType === EPlacingType.package} onChange={handlePackageChange} />;
};
